export default __webpack_public_path__ + "static/media/no_image_found.ec55f8a2.jpg";